import type { EEGCalibrationEnvironment } from "./types"

export const captureEnvironment = (): EEGCalibrationEnvironment | undefined => {
	if (typeof window === "undefined") {
		return undefined
	}

	return {
		screenWidth: window.screen.width,
		screenHeight: window.screen.height,
		devicePixelRatio: window.devicePixelRatio ?? 1,
		visualViewportScale: window.visualViewport?.scale ?? 1,
	}
}

/**
 * The signature is used to generate the storage key for a particular calibration
 * Fields:
 * - effectiveScale: devicePixelRatio * visualViewportScale
 * - resolution: screen resolution lets us distinguish between different monitors
 */
export const buildEnvSignature = (env: EEGCalibrationEnvironment): string => {
	const effectiveScale = (env.devicePixelRatio * env.visualViewportScale).toFixed(4)
	const screenClass = `${env.screenWidth}x${env.screenHeight}`
	return JSON.stringify({ effectiveScale, screenClass })
}
